export const handleShowTYPE = (value) => {
    const contractTypeMap = {
        "lsfhp": "สัญญา 1",
        "vsfhp": "สัญญา 2",
        "psfhp": "สัญญา 3",
        "rpsl": "สัญญา 3(ใหม่)",
        "sfhp": "สัญญา 8",
    };
    return contractTypeMap[value] || "-";
};

export const handleShowTypeReply = (value) => {
    const typeReplyMap = {
        1: "บอกกล่าวคนค้ำ",
        2: "สิทธิซื้อรถคืน",
        3: "แจ้งราคาขายรถ",
        4: "บอกเลิก",
    };
    return typeReplyMap[value] || "-";
};


export function colorStatusDG(Status) {
    if (Status === 501) {
        return "green"
    } else if (Status === 401) {
        return "red"
    } else {
        return "orange"
    }
}

export function getStatusColor(status) {
    switch (status) {
        case 'ทั้งหมด': return 'blue';
        case 'บอกกล่าว': return 'cyan';
        case 'บอกกล่าว(มือ)': return 'cyan';
        case 'สิทธิซื้อรถคืน': return 'purple';
        case 'สิทธิซื้อรถคืน(พี่นิ๊กกี้)': return 'purple';
        case 'แจ้งราคาขายรถ': return 'orange';
        case 'บอกเลิก': return 'magenta';
        case 'บอกเลิก(มือ)': return 'magenta';
        case 'อยู่ระหว่างการนำจ่าย': return 'orange';
        case 'นำจ่ายไม่สำเร็จ': return 'red';
        case 'นำจ่ายสำเร็จ': return 'green';
        case 'รอคอนเฟิร์ม': return 'orange';
        case 'คอนเฟิร์มแล้ว': return 'green';
        case 'ตอบกลับ': return 'volcano';
        case 'ตีกลับ': return 'volcano';
        default: return 'default';
    }
};

export function getTypeReplyName(status) {
    switch (status) {
        case 1: return 'บอกกล่าว';
        case 2: return 'สิทธิซื้อรถคืน';
        case 3: return 'แจ้งราคาขายรถ';
        case 4: return 'บอกเลิก';
        default: return '-';
    }
};